<template>
  <div>
    <div class="langage" v-if="viewWidth >= 854">
      <span @click="toggleLang('zh')"> 简体中文</span>|<span
        @click="toggleLang('en')"
        >English</span
      >
    </div>
    <div>
      <div class="head-nv">
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <img src="../assets/imgs/logo.png" alt=""
          /></el-col>
          <el-col :span="12">
            <div class="searchall">
              <!-- <i class="el-icon-user"></i>
              <span>{{ $t('navbar.LOGIN') }}</span> -->
              <div v-if="viewWidth >= 1260">
                <el-input placeholder="Search" clearable v-model="searchAll">
                  <template slot="append">
                    <div @click="fun(`/searchItem?keyword=${searchAll}`)">
                      {{ $t("navbar.Search") }}
                    </div>
                  </template>
                </el-input>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <HeadItem />
    <div class="preview-wrap" v-if="routePath == 0">
      <el-carousel
        :interval="5000"
        arrow="always"
        :height="viewWidth >= 1920 ? '400px' : '6.6667rem'"
      >
        <el-carousel-item v-for="item in imgItem" :key="item.id">
          <img
            :src="item.image"
            alt=""
            @click.prevent="bannerRoute(item)"
            v-if="item.status"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <router-view />
    <FootItem />
  </div>
</template>

<script>
import { banner } from "@/api/link";
import FootItem from "@/components/home/FootItem.vue";
import HeadItem from "@/components/home/HeadItem.vue";
export default {
  name: "HelloWorld",
  components: {
    HeadItem,
    FootItem,
  },
  data() {
    return {
      viewWidth: null,
      bool: false,
      noSearch: false,
      searchAll: "",
      printValue: "BEM",
      resLength: 0,
      allData: false,
      viewWidth: window.innerWidth,
      routePath: null,
      imgItem: [
        {
          id: 1,
          img: "https://new.omniscient.sg/upload/admin/20230411/0445daa0a5f63cfd4a6544e9c538d509.jpg",
        },
      ],
    };
  },
  watch: {
    $route() {
      if (this.$route.path == "/specialIssues") {
        this.routePath = 1;
      } else if (this.$route.path == "/specialIssuesInfo") {
        this.routePath = 1;
      } else {
        this.routePath = 0;
      }
    },
  },
  created() {
    if (this.$route.path == "/specialIssues") {
      this.routePath = 1;
    } else if (this.$route.path == "/specialIssuesInfo") {
      this.routePath = 1;
    } else {
      this.routePath = 0;
    }
  },
  mounted() {
    // 实时获取浏览器当前宽度
    window.onresize = () => {
      const viewWidth = window.innerWidth;
      this.viewWidth = viewWidth;
    };
    banner().then((res) => {
      if (res.code == 0) {
        if (this.viewWidth >= 854) {
          this.imgItem = res.data.pc_banner;
        } else {
          this.imgItem = res.data.mb_banner;
        }
      } else {
        this.$message({
          message: "网关错误！",
          type: "error",
        });
      }
    });
  },
  methods: {
    fun(val) {
      this.$router.push(val);
    },
    bannerRoute(item) {
      if (item.type == "article") {
        this.$router.push({
          name: "bookInfo",
          query: { type: item.type_id, id: item.data_id },
        });
      }
    },
    //切换方法
    toggleLang(lang) {
      this.$i18n.locale = lang;
    },
  },
};
</script>

<style scoped lang="scss">
.preview-wrap .el-carousel {
  height: 6.6667rem;

  img {
    width: 100%;
    height: 6.6667rem;
  }
}

.head-nv {
  width: 20rem;
  margin-left: auto;
  margin-right: auto;

  img {
    height: 1.7rem;
  }
}

.langage {
  text-align: right;
  margin-right: 0.25rem;
  font-size: 0.2rem;
  cursor: pointer;
}

.searchall >>> .el-input-group__append {
  background: #0273c6;
  border-radius: 0 0.0667rem 0.0667rem 0;
  font-size: 0.2rem;
  color: #fff;
}

.el-icon-user {
  color: #0273c6;
  line-height: 1.7rem;
  font-size: 0.6rem;
  padding: 0 0.1667rem;
}

.el-input-group--append .el-input__inner,
.el-input-group__prepend {
  height: 1.7rem;
}

.el-input__inner {
  width: 1.3333rem;
}

.el-input-group__append {
  width: 0.5rem;
}

.searchall {
  // display: flex;
  // justify-content: center;
  width: 55%;
  float: right;
  line-height: 1.7rem;
}

.searchall span {
  line-height: 1.7rem;
  // padding-right: 0.1667rem;
  font-size: 0.266667rem;
}

@media screen and (max-width: 854px) {
  .head-nv img {
    height: 3rem;
  }

  .langage {
    font-size: 12px;
    padding: 10px 10px 0 0;
  }

  .searchall {
    height: 3rem;
    font-size: 14px !important;

    .el-icon-user {
      line-height: 3rem !important;
      font-size: 20px !important;
    }

    span {
      line-height: 3rem !important;
      font-size: 13px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue